import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';

export const local: PartialCarConfiguration = {
	hasJetStream: true,
	showCaESummaryText: true,
	engineCardKeyfacts: ['acceleration', 'maxPowerHp', 'chargingTime'],
	financingDisclaimer: ['globalDisclaimer'],
	financeDomain: 'AUDI.IE',
	showFinancingDisclaimerInDialogs: true,
	summaryFooterCta: {
		description: 'Audi Code',
		icon: 'code',
		labelText: 'Audi Code',
		target: '_blank',

		trackingName: 'show audicode',
		url: '',
	},
	useStaticPriceDateRemark: true,
	uiPreferences: {
		prices: {
			totalPriceFrom: 'totalWithCharges',
			vatConfig: {
				feature: 'inclusive',
				trimlineAndEngine: 'inclusive',
				totalPrice: 'inclusive',
				priceParts: {},
			},
			hiddenPriceParts: ['total', 'totalWithCharges'],
		},
	},
};
